module.exports = __webpack_public_path__ + "img/welcome-ar.d54a4406.png";